module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.patientid) ? _c('h3', [_vm._v("Edit Patient Details")]) : _c('h3', [_vm._v("Create New Patient")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('NewPatientForm', {
    attrs: {
      "patientid": _vm.patientid
    },
    model: {
      value: (_vm.Patient),
      callback: function($$v) {
        _vm.Patient = $$v
      },
      expression: "Patient"
    }
  })], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-665c51a3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-665c51a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/FmdControls/Patients/NewPatient.scp.html
// module id = 554
// module chunks = 0